import React, {useEffect, useState} from 'react';
import {useSelector, useDispatch} from "react-redux";
import MindsetsJsSDK from "mindsets-js-sdk";
import {orderBy, uniqWith, find, isEqual, filter} from 'lodash';
import {SetDashboardDataAction} from '../../actions/performance_actions';

import GrowthTable from './GrowthTable';

import "./insights-super.scss";
import GrowthMinSelect from './GrowthMinSelect';
import DataSelect from './DataSelect';

export const INSIGHT_LEVELS = ['not_met', 'nearly_met', 'met', 'exceeded'];

export default function() {
    const dispatch = useDispatch();

    const [growthMin, setGrowthMin] = useState(10);
    const [selectedDistrictId, setSelectedDistrictId] = useState(0);
    const [selectedSchoolId, setSelectedSchoolId] = useState(0);
    const [selectedFrom, setSelectedFrom] = useState(null);
    const [selectedTill, setSelectedTill] = useState(null);
    const [disabledImpactStudies, setDisabledImpactStudies] = useState([]);

    const dashboard_data = useSelector(state => state.dashboard_data);

    function loadData() {
        if (!selectedDistrictId) {
            return false;
        }

        MindsetsJsSDK().API.get(`dashboards/super`, {
            district_id: selectedDistrictId ?? '',
            school_id: selectedSchoolId ?? '',
            from: selectedFrom ?? '',
            till: selectedTill ?? '',
            disabled_impact_studies: disabledImpactStudies
        }).then((response) => {
            dispatch(SetDashboardDataAction({super_impact: response.impact}));
            dispatch(SetDashboardDataAction({super_impact_const: response.impact_const}));

            dispatch(SetDashboardDataAction({super_skill: response.skill}));
            dispatch(SetDashboardDataAction({super_skill_const: response.skill_const}));

            dispatch(SetDashboardDataAction({super_school: response.school}));
            dispatch(SetDashboardDataAction({super_school_const: response.school_const}));

            dispatch(SetDashboardDataAction({super_grade: response.grade}));
            dispatch(SetDashboardDataAction({super_grade_const: response.grade_const}));

            dispatch(SetDashboardDataAction({super_category: response.category}));
            dispatch(SetDashboardDataAction({super_category_const: response.category_const}));

            dispatch(SetDashboardDataAction({super_domain: response.domain}));
            dispatch(SetDashboardDataAction({super_domain_const: response.domain_const}));
        });
    }

    useEffect(() => {
        setDisabledImpactStudies([]);
    }, [selectedDistrictId]);

    useEffect(() => {
        loadData();
    }, [selectedSchoolId, selectedFrom, selectedTill]);

    useEffect(() => {
        loadData();
    }, [disabledImpactStudies]);

    const growth_insights = {};
    const addData = (title, super_const, super_data, matchFunc) => {
        if (!super_data) {
            return false;
        }
        if (growth_insights[title] === undefined) {
            growth_insights[title] = [];
        }

        super_const.map((const_d) => {
            const row_data = dashboard_data.super_impact_const.map((impact_d) => {
                const data = find(super_data, matchFunc(const_d, impact_d));
                if (data === undefined) return null;
                return INSIGHT_LEVELS.map((level) => {
                    return {
                        data,
                        level,
                        percentage: getPercentage(data, level)
                    };
                });
            });
            growth_insights[title].push(row_data);
        });
    }
    addData('impact', [1], dashboard_data.super_impact, (const_d, impact_d) => (data) => {
        return data.impact_study == impact_d;
    });
    addData('skill', dashboard_data.super_skill_const, dashboard_data.super_skill, (const_d, impact_d) => (data) => {
        return data.impact_study == impact_d && data.practice_skill_code == const_d.code;
    });
    addData('category', dashboard_data.super_category_const, dashboard_data.super_category, (const_d, impact_d) => (data) => {
        return data.impact_study == impact_d && data.category == const_d;
    });
    addData('domain', dashboard_data.super_domain_const, dashboard_data.super_domain, (const_d, impact_d) => (data) => {
        return data.impact_study == impact_d && data.domain == const_d;
    });
    addData('grade', dashboard_data.super_grade_const, dashboard_data.super_grade, (const_d, impact_d) => (data) => {
        return data.impact_study == impact_d && isEqual(data.class_grade, const_d);
    });
    addData('school', dashboard_data.super_school_const, dashboard_data.super_school, (const_d, impact_d) => (data) => {
        return data.impact_study == impact_d && data.school_id == const_d.id;
    });
    console.log('growth_insights', growth_insights);

    return (
        <div id="insights-super">
            <div className="section">
                <h2 className="header-new">{`Super Insights (Growth)`}</h2>
            </div>

            <div className="flex-column flex-gap-20">
                <DataSelect
                    selectedDistrictId={selectedDistrictId}
                    setSelectedDistrictId={setSelectedDistrictId}
                    selectedSchoolId={selectedSchoolId}
                    setSelectedSchoolId={setSelectedSchoolId}
                    selectedFrom={selectedFrom}
                    setSelectedFrom={setSelectedFrom}
                    selectedTill={selectedTill}
                    setSelectedTill={setSelectedTill}
                />

                <GrowthMinSelect
                    growthMin={growthMin}
                    setGrowthMin={setGrowthMin}
                />
            </div>

            <div className="section">
                {`Figures below show % students (not student scores).`}
            </div>

            <div className="section">
                <GrowthTable
                    growth_insights={growth_insights}
                    growthMin={growthMin}
                    disabledImpactStudies={disabledImpactStudies}
                    setDisabledImpactStudies={setDisabledImpactStudies}
                />
            </div>
        </div>
    );
}

const getPercentage = (d, level) => {
    if (!d[level]) {
        return 0;
    }

    return Math.round(d[level] / d.total * 100);
}